import React from 'react';
import { H1 } from '../typography/Title';

// Shared chrome for the signed-out pages (login, register, recover, reset) and
// the forced password change. It fills the space between the header and the
// footer. `flex-1` stretches it on a short viewport so the footer still lands
// at the bottom of the screen; a form taller than the viewport just scrolls the
// page as normal.
function AuthLayout({ title, children, wide }) {
  return (
    <div className="relative flex flex-1 bg-login bg-cover bg-center">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-ink/75 via-ink/55 to-gold-900/60" />
      <div className="relative m-auto grid w-full max-w-screen-2xl items-center gap-10 px-4 py-8 md:px-6 lg:grid-cols-2">
        <div className="hidden lg:block">
          <H1 className="max-w-xl text-white" text={title} />
        </div>
        <div
          className={`mx-auto w-full ${wide ? 'max-w-2xl' : 'max-w-md'} rounded-card border border-line bg-surface p-6 shadow-pop sm:p-8`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
